goog.provide("shadow.js.shim.module$$dnd_kit$core");
goog.provide("module$shadow_js_shim_module$$dnd_kit$core");
shadow.js.shim.module$$dnd_kit$core = shadow.js.nativeProvides["@dnd-kit/core"] = shadow$bridge("@dnd-kit/core");
module$shadow_js_shim_module$$dnd_kit$core.default = shadow.js.shim.module$$dnd_kit$core;
